import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '@/store';
import type {Editor} from 'grapesjs';
import {EmailEditorAiPromptBoxVariant} from '@Libraries/ai-email-campaign-content-library';

type ComponentId = string;
type LoadingComponents = Record<ComponentId, boolean>;

interface StateProps {
  loadingComponents: LoadingComponents;
}

const initialState: StateProps = {
  loadingComponents: {},
};

export const emailMakerAiTextPromptBoxSlice = createSlice({
  name: 'emailMakerAiTextPromptBox',
  initialState,
  reducers: {
    addLoadingComponent(state, action: PayloadAction<string>) {
      const componentID = action.payload;
      state.loadingComponents[componentID] = true;
    },
    removeLoadingComponent(state, action: PayloadAction<string>) {
      const componentID = action.payload;
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete state.loadingComponents[componentID];
    },
  },
});

export const {addLoadingComponent, removeLoadingComponent} = emailMakerAiTextPromptBoxSlice.actions;
export const emailMakerAiTextPromptBoxReducer = emailMakerAiTextPromptBoxSlice.reducer;

export const isComponentLoading = (state: RootState, componentId: string): boolean => {
  return Boolean(state.emailMakerAiTextPromptBox.loadingComponents[componentId]);
};

export const loadingComponentExists = (state: RootState): boolean => {
  return Object.keys(state.emailMakerAiTextPromptBox.loadingComponents).length > 0;
};

export const isLoading = (state: RootState, emailEditorAiPromptBoxVariant: EmailEditorAiPromptBoxVariant, editor: Editor): boolean => {
  switch (emailEditorAiPromptBoxVariant) {
    case EmailEditorAiPromptBoxVariant.SINGLE_TEXT_EDITOR:
    case EmailEditorAiPromptBoxVariant.SINGLE_TEXT_EDITOR_DROPDOWN: {
      const selectedComp = editor.getSelected();
      if (!selectedComp) {
        return false;
      }
      return isComponentLoading(state, selectedComp.ccid);
    }
    case EmailEditorAiPromptBoxVariant.TEMPLATE_EDITOR:
      return loadingComponentExists(state);
  }
};
